angular
  .module('surfsightApp.controllers')
  .controller('EdgeRecordingVideoController', [
    '$scope',
    '$timeout',
    '$interval',
    '$http',
    '$localStorage',
    '$mdDialog',
    '$mdToast',
    'dataFromCaller',
    function (
      $scope,
      $timeout,
      $interval,
      $http,
      $localStorage,
      $mdDialog,
      $mdToast,
      dataFromCaller
    ) {
      $scope.recording = dataFromCaller.recording
      // ~ console.log($scope.recording)
      $scope.edge = dataFromCaller.edge
      $scope.recording.file_exists = false
      $scope.recording.retry_count = 0
      $scope.recording.play_status = true
      $scope.dialog_status = true
      $scope.recording.upload_command_sent = false
      let videoId = 'recording-' + $scope.recording.id + '-video'
      let videoPresignedURLTimeout = null
      $scope.recording_video_toggle = false
      $scope.recording.videoId = videoId
      $scope.playRecordingVideo = function () {
        $scope.recording_video_toggle = false
        $timeout(function () {
          $scope.recording_video_toggle = true
          $timeout(function () {
            // adding listers for video status bar
            let elem = document.getElementById(videoId)
            elem.addEventListener(
              'loadeddata',
              function () {
                // play video
                elem.play()
              },
              false
            )
            elem.addEventListener(
              'timeupdate',
              function () {
                seektimeupdate(videoId)
              },
              false
            )
            elem.addEventListener(
              'ended',
              function () {
                updatePlayPauseIcon(videoId)
              },
              false
            )
          })
        })
      }

      function seektimeupdate (videoId) {
        let vid = document.getElementById(videoId)
        if (vid) {
          var nt = vid.currentTime * (100 / vid.duration)
          var seeksliderID = 'seekslider-' + videoId
          var seekslider = document.getElementById(seeksliderID)
          seekslider.value = nt
          var curmins = Math.floor(vid.currentTime / 60)
          var cursecs = Math.floor(vid.currentTime - curmins * 60)
          var durmins = Math.floor(vid.duration / 60)
          var dursecs = Math.floor(vid.duration - durmins * 60)
          if (cursecs < 10) {
            cursecs = '0' + cursecs
          }
          if (dursecs < 10) {
            dursecs = '0' + dursecs
          }
          if (curmins < 10) {
            curmins = '0' + curmins
          }
          if (durmins < 10) {
            durmins = '0' + durmins
          }
          var curtimetextID = 'curtimetext-' + videoId
          var durtimetextID = 'durtimetext-' + videoId
          var curtimetext = document.getElementById(curtimetextID)
          var durtimetext = document.getElementById(durtimetextID)
          curtimetext.innerHTML = curmins + ':' + cursecs
          durtimetext.innerHTML = durmins + ':' + dursecs
        }
      }
      function updatePlayPauseIcon () {
        $scope.recording.play_status = false
        $scope.$apply()
      }
      $scope.setFullscreen = function () {
        try {
          var elem = $scope.recording.videoId
          elem = document.getElementById(elem)
          if (elem.requestFullscreen) {
            elem.requestFullscreen()
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen()
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen()
          } else if (elem.webkitEnterFullScreen != undefined) {
            elem.webkitEnterFullScreen() // Safari
          }
        } catch (e) {}
      }
      $scope.play_pause_video = function () {
        var elem = $scope.recording.videoId
        elem = document.getElementById(elem)
        // elem.addEventListener('timeupdate',  function(){ seektimeupdate(edge_event.id,eventurl.id); }, false);
        if (elem.paused) {
          elem.play()
          $scope.recording.play_status = true
        } else {
          elem.pause()
          $scope.recording.play_status = false
        }
      }
      $scope.getVideoPresignedURL = function (timeoutPeriod = false) {
        if (timeoutPeriod) {
          $timeout(function () {
            if (!$scope.recording.file_exists) {
              $timeout.cancel(videoPresignedURLTimeout)
              $mdDialog.hide('timeout')
            }
          }, 10 * 60 * 1000)
        }
        if (!$scope.dialog_status) return
        var request_json = {
          method: 'POST',
          url: EDGE_BASEURL + '/edge/' + $scope.edge.id + '/recording_url',

          data: {
            file_name: $scope.recording.file_utc || $scope.recording.file
          }
        }
        $http(request_json).then(
          function (response) {
            // ~ console.log(response);
            $scope.recording.url = response.data.url
            $scope.recording.file_exists = response.data.file_exists
            if ($scope.recording.file_exists) {
              $scope.playRecordingVideo()
            } else {
              $scope.recording.retry_count++
              if ($scope.recording.upload_command_sent) {
                videoPresignedURLTimeout = $timeout(function () {
                  $scope.getVideoPresignedURL()
                }, 25 * 1000)
              } else {
                $scope.request_recording_upload()
              }
            }
            // var exists=doesFileExist($scope.recording.url);
          },
          function (response) {
            $scope.getVideoPresignedURL()
          }
        )
      }
      $scope.getVideoPresignedURL(true)
      $scope.request_recording_upload = function () {
        var request_json = {
          method: 'POST',
          url: EDGE_BASEURL + '/request_recording_upload/' + $scope.edge.id,

          data: {
            file_name: $scope.recording.file_utc || $scope.recording.file
          }
        }
        $http(request_json).then(
          function (response) {
            $scope.recording.upload_command_sent = true
            videoPresignedURLTimeout = $timeout(function () {
              if ($scope.dialog_status) {
                $scope.getVideoPresignedURL()
              }
            }, 25 * 1000)
          },
          function (response) {
            $scope.getVideoPresignedURL()
          }
        )
      }
      $scope.cancel = function () {
        $scope.dialog_status = false
        $mdDialog.hide()
      }
      $scope.updateProgressBarStaus = function () {
        var elem = $scope.recording.videoId
        vid = document.getElementById(elem)
        if (vid) {
          var seeksliderID = 'seekslider-' + elem
          var seekslider = document.getElementById(seeksliderID)
          var seekto = vid.duration * (seekslider.value / 100)
          vid.currentTime = seekto
        }
      }
    }
  ])
